<template>
  <b-modal
      ref="create-bonus"
      size="lg"
      :title="$t('bonus.edit_active')"
  >
    <b-form>
      <b-form-group
          :label="$t('bonus.form.valid_to')"
          label-for="validTo"
          label-cols-lg="3"
      >
        <date-range-picker v-model="form.validTo"
                           :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                           :auto="false"
                           :linked="false"
                           style="width: 100%;"
                           :singleDatePicker="true"
                           :show-week-numbers="false"
                           :time-picker="true"
                           filter-name="createdAt"
                           ranges="false"
                           :opens="'center'"
                           :label="$t('bonus.form.valid_to')"
                           :timePicker24Hour="false">
          <template v-slot:input="picker" style="width: 1350px;">
            {{ picker.startDate | date }}
          </template>
        </date-range-picker>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
// import {required} from "vuelidate/lib/validators";
import axios from "axios";
import DateRangePicker from "../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";

export default {
  components: {
    DateRangePicker
  },
  data() {
    return {
      bonus: null,
      busy: false,
      form: {
        validTo: {
          startDate: ''
        }
      },
    }
  },
  validations: {
    form: {
      validTo: {

      }
    }
  },
  filters: {
    date: function (value) {
      if (value) {
        return new moment(value).format('YYYY-MM-DD hh:mm a');
      }
    },
  },
  mounted() {
    this.openModal();
  },
  methods: {
    submit() {
      this.$v.$touch();

      const payload = {
        id: this.bonus.id,
        validTo: this.form.validTo.startDate
      }

      if(!this.$v.invalid) {
        axios.post('/api/bonus-definition/edit-active', payload).then(() => {
          this.$emit('refreshGrid');
          this.hideModal();
        })
        .catch((err) => {
          console.log(err)
        })
      }
    },
    openModal(item) {
      if(item) {
        this.bonus = item;
        this.form.validTo.startDate = item.validTo;
        this.$refs['create-bonus'].show();
      }
    },
    hideModal() {
      this.$refs['create-bonus'].hide();
    }
  }
}
</script>
